import React from 'react';
import { AttachmentData, AttachModalProps } from '@v2/components/imageHandling/components/Header/components/AttachModal';
import { isPhone, isWeb, Popup } from '@helpers';
import { fullWidth } from '@components/frame';
import SearchAttachmentPopup from '@v2/components/imageHandling/components/Header/components/AttachModal/SearchAttachmentPopup';

interface UseManageAttachModalParams extends Pick<AttachModalProps, 'onClose' | 'fileName' | 'imageId' | 'onAttach' | 'img'> {}

export const useManageAttachModal = ({ onClose, imageId, fileName, onAttach, img }: UseManageAttachModalParams) => {
  const onAttachPress = () => {
    onClose();
    // Open search in popup for attachment mode
    Popup({
      Component: (props: any) => (
        <SearchAttachmentPopup
          {...props}
          imageDocument={img}
          suggestionODataFilter="ItemType ne 'ImageDocument' and ItemType ne 'OtherDocument'"
          attachImageId={imageId}
          fileName={fileName}
          onAttachSuccess={(attachmentData: AttachmentData) => {
            // Refresh the attach modal data if needed
            console.log('Item attached successfully:', attachmentData);
            // The parent component should handle refreshing the links/attachments
            if (onAttach) {
              onAttach(attachmentData);
            }
          }}
        />
      ),
      width: isPhone || !isWeb ? '100%' : fullWidth - 400,
      useFullHeight: !isWeb,
      offsetTop: !isWeb ? 0 : undefined,
      offsetBottom: !isWeb ? 0 : undefined,
      bg: !isWeb ? 'Background/Light/System' : undefined,
      bottomSheet: !isPhone,
    });
  };

  return { onAttachPress };
};
